
import React, { useState } from "react";
import { db, collection, getDocs, query, where, limit } from "../../../firebaseClient";
import { fetchReadOnlyApprovalStatus } from "../../services/approvalReadOnlyViewService";
import { useToast } from "../Toast";
import { downloadJson } from "../../utils/download";

export function ApprovalRepairTab() {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [scanLimit, setScanLimit] = useState(50);
  const [results, setResults] = useState<any[]>([]);

  const runClientScan = async () => {
    setLoading(true);
    setResults([]);
    try {
        // 1. Fetch Contract Drafts
        const q = query(
            collection(db, "approval_requests"), 
            where("module", "==", "contractDraft"),
            limit(scanLimit)
        );
        const snap = await getDocs(q);
        const items = snap.docs.map(d => ({ id: d.id, ...d.data() }));

        // 2. Scan each for Flow
        const scanResults = [];
        for (const item of items) {
            const statusInfo = await fetchReadOnlyApprovalStatus(
                "contractDraft", 
                item.id, 
                (item as any).docCode
            );
            
            // Logic to determine if "Missing" or "Mismatch"
            // Mismatch: Item has status "IN_REVIEW" but Flow is "MISSING"
            // Or Item has status "DRAFT" but Flow exists
            
            const isMissingFlow = !statusInfo.hasFlow && (item as any).status !== 'DRAFT';
            const isMismatch = statusInfo.hasFlow && statusInfo.status !== (item as any).status;
            
            if (isMissingFlow || isMismatch || statusInfo.hasFlow) {
                scanResults.push({
                    reqId: item.id,
                    title: (item as any).title,
                    docCode: (item as any).docCode,
                    currentDocStatus: (item as any).status,
                    flowStatus: statusInfo.status,
                    flowStage: statusInfo.currentStageLabel,
                    flowId: statusInfo.flowId,
                    issue: isMissingFlow ? "MISSING_FLOW" : (isMismatch ? "STATUS_MISMATCH" : "OK")
                });
            }
        }
        
        setResults(scanResults);
        showToast(`掃描完成: ${scanResults.length} 筆 (含正常與異常)`);
    } catch (e: any) {
        console.error(e);
        showToast("掃描失敗: " + e.message, "error");
    } finally {
        setLoading(false);
    }
  };

  const handleExport = () => {
      downloadJson("approval_scan_results.json", results);
  };

  return (
    <div style={{display:'flex', flexDirection:'column', gap: 20}}>
        <div className="section">
            <h3 className="h1" style={{color: '#f472b6'}}>合約草案審查｜簽核流程還原工具 (唯讀)</h3>
            <p className="p" style={{marginBottom: 16}}>
                此工具會從前端掃描「合約草案審查」請求，並嘗試尋找對應的 Approval Flow 文件。
                <br/>僅執行讀取與比對，<b style={{color:'#fff'}}>不會對資料庫進行任何寫入</b>。
                <br/>可用於診斷「進度顯示異常」或「流程遺失」的案件。
            </p>
            
            <div style={{display:'flex', alignItems:'center', gap: 12, marginBottom: 16}}>
                <label className="label">掃描筆數限制</label>
                <input 
                    type="number" 
                    className="input" 
                    style={{width: 100}} 
                    value={scanLimit} 
                    onChange={e => setScanLimit(Number(e.target.value))} 
                />
            </div>

            <div style={{display:'flex', gap: 12}}>
                <button className="btn" style={{width:'auto', background:'#3b82f6', color:'#fff', border:'none'}} onClick={runClientScan} disabled={loading}>
                    {loading ? "掃描中..." : "開始掃描 (Read Only)"}
                </button>
                {results.length > 0 && (
                    <button className="btn" style={{width:'auto'}} onClick={handleExport}>
                        匯出 JSON
                    </button>
                )}
            </div>
        </div>

        {results.length > 0 && (
            <div className="section">
                <h4 className="h1">掃描結果 ({results.length})</h4>
                <div style={{maxHeight: 500, overflow:'auto', border:'1px solid #333', borderRadius: 8}}>
                    <table style={{width:'100%', borderCollapse:'collapse', fontSize: 12}}>
                        <thead style={{background:'#222', color:'#aaa', textAlign:'left', position:'sticky', top:0}}>
                            <tr>
                                <th style={{padding:8}}>Issue</th>
                                <th style={{padding:8}}>Req ID</th>
                                <th style={{padding:8}}>Title</th>
                                <th style={{padding:8}}>Doc Status</th>
                                <th style={{padding:8}}>Flow Status</th>
                                <th style={{padding:8}}>Detected Stage</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map((r: any, idx) => (
                                <tr key={idx} style={{borderBottom:'1px solid #333'}}>
                                    <td style={{padding:8, fontWeight:'bold', color: r.issue === 'OK' ? 'var(--ok)' : 'var(--danger)'}}>
                                        {r.issue}
                                    </td>
                                    <td style={{padding:8, fontFamily:'monospace', color:'#666'}}>{r.reqId.slice(0,8)}</td>
                                    <td style={{padding:8}}>{r.title}</td>
                                    <td style={{padding:8}}>{r.currentDocStatus}</td>
                                    <td style={{padding:8}}>{r.flowStatus}</td>
                                    <td style={{padding:8, color:'#a5b4fc'}}>{r.flowStage}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        )}
    </div>
  );
}

